define([], ()=> {
    // Adaptation of the regular expression for the email address to bring the validation closer to the RFC 5322 specification.
    // (For example, points at the beginning and end of the local part or two points in a row are not allowed)
    const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"\x7f-\xff]+(\.[^<>()\[\]\\.,;:\s@"\x7f-\xff]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6})$/;

    /* Garog : The aim of this decorator is the override the default angular email validation which returns undefined when the view value
     fails validation. This has the knock on effect of not setting the model value, which messes with our own DTO validation.
     */
    return function ($provide) {
        $provide.decorator('inputDirective', ['$delegate', function ($delegate) {
            const directive = $delegate[0];
            const link = directive.link;

            directive.compile = function () {
                return function (scope, element, attrs, ctrl) {
                    link.pre.apply(this, arguments); // Otherwise the formatters and parsers aren't there yet
                    if (attrs.type === 'email') {
                        const emailValidator = (value)=> {
                            if (ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value)) {
                                ctrl.$setValidity('email', true);
                            } else {
                                ctrl.$setValidity('email', false);
                            }
                            return value;
                        };
                        ctrl.$formatters = [emailValidator];
                        ctrl.$parsers = [emailValidator];
                    }
                };
            };

            return $delegate;
        }]);
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/decorator/EmailInputDecorator.js